// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tleegzfiavyqlmshtwkf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRsZWVnemZpYXZ5cWxtc2h0d2tmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxNjczMDYsImV4cCI6MjA3MTc0MzMwNn0.FBOo_JJzUeYVegkyRrnxeS3w4YQwhc-1shO-_KNtgtM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});